import { ProgressTracking } from "@/components/ProgressTracking";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Progress3 = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-gray-50 p-8">
      <Button
        onClick={() => navigate("/")}
        variant="outline"
        className="mb-8"
      >
        Back to Home
      </Button>
      <ProgressTracking 
        familyName="Pollak Family"
        googleDriveUrl="https://drive.google.com/drive/folders/1JjD6FFmbA6ux8Bg0R2jx4v5WBHYLTgEF"
        password="pollak"
      />
    </div>
  );
};

export default Progress3;